module.exports = __webpack_public_path__ + "img/symbol_5.4485e38c.png";